import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";

export interface SanctionNoteDialogProps {
  readonly open: boolean;
  readonly title: string;
  readonly description: string;
  readonly label: string;
  readonly confirmLabel: string;
  readonly destructive?: boolean;
  readonly pending: boolean;
  readonly onCancel: () => void;
  readonly onConfirm: (note: string) => void;
}

const MAX_NOTE = 1000;

/** A required note (shown to the club) before a reject, return, close or revoke. */
export function SanctionNoteDialog({
  open,
  title,
  description,
  label,
  confirmLabel,
  destructive = false,
  pending,
  onCancel,
  onConfirm,
}: SanctionNoteDialogProps) {
  const [note, setNote] = useState("");
  useEffect(() => {
    if (open) setNote("");
  }, [open]);
  const trimmed = note.trim();

  return (
    <Dialog
      open={open}
      onClose={pending ? undefined : onCancel}
      fullWidth
      maxWidth="sm"
      aria-labelledby="sanction-note-title"
    >
      <DialogTitle
        id="sanction-note-title"
        sx={{ fontSize: 16, fontWeight: 700 }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {description}
        </Typography>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={3}
          size="small"
          label={label}
          value={note}
          onChange={(event) => setNote(event.target.value.slice(0, MAX_NOTE))}
          helperText={`${note.length}/${MAX_NOTE}`}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={pending} color="inherit">
          Cancel
        </Button>
        <Button
          variant="contained"
          color={destructive ? "error" : "primary"}
          disabled={pending || trimmed.length === 0}
          onClick={() => onConfirm(trimmed)}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
